'use client'

import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

type ToastStore = {
  active: { text: string; key: number; pop: boolean }[]
  push: (text: string) => void
  pop: (key: number) => void
}

export const useToast = create(
  immer<ToastStore>((set, get) => ({
    active: [],
    push: (text: string) =>
      set((state) => {
        state.active = []
        state.active.push({ text, key: Math.random(), pop: false })
      }),
    pop: (key: number) =>
      set((state) => {
        const idx = state.active.findIndex((ac) => ac.key === key)

        if (idx > -1) {
          state.active.splice(idx, 1)
        }
      }),
  })),
)

export const ToastContainer = () => {
  const toast = useToast()

  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)

    return useToast.subscribe((state, prev) => {
      for (const active of state.active) {
        if (!active.pop) {
          setTimeout(() => {
            state.pop(active.key)
          }, 2500)
        }
      }
    })
  }, [])

  if (!loaded) {
    return
  }

  return ReactDOM.createPortal(
    <div className="fixed pc:top-[4.5rem] top-12 left-1/2 -translate-x-1/2 z-[9999] flex flex-col gap-3 pointer-events-none">
      <AnimatePresence>
        {toast.active[0] && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="bg-black-40 rounded-lg p-4 w-96 max-w-[100vw] text-white font-medium text-body1 text-center leading-tight"
          >
            {toast.active[0].text}
          </motion.div>
        )}
      </AnimatePresence>
    </div>,
    document.querySelector('#root-backdrop')!,
  )
}
